import { render, staticRenderFns } from "./MetaYearReview.vue?vue&type=template&id=47f5117a&scoped=true&"
import script from "./MetaYearReview.vue?vue&type=script&lang=ts&"
export * from "./MetaYearReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5117a",
  null
  
)

export default component.exports